// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"a5c91e6cfd37cebe7b56","655":"0e86a6287ac454811aba"}[chunkId] + ".js";
};